if (!customElements.get('tp-categories-media')) {
  class TpCategoriesMedia extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;

      this.autoplay = this.dataset.autoplay === 'true';
      if (!this.autoplay) return;

      this.video.muted = true;
      this.video.setAttribute('muted', '');
      this.video.playsInline = true;

      if (!('IntersectionObserver' in window)) {
        this.video.play().catch(() => {});
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.video.play().catch(() => {});
            } else {
              this.video.pause();
            }
          });
        },
        { threshold: 0.25 }
      );
      this.observer.observe(this.video);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  customElements.define('tp-categories-media', TpCategoriesMedia);
}
